export const MOTION_TIMING = Object.freeze({
  heroStagger: 0.11,
  heroDuration: 0.86,
  sectionDuration: 0.72,
  projectDuration: 0.68
});

export const editorialEase = [0.76, 0, 0.24, 1];

export function clampProjectIndex(index, count) {
  if (count <= 1) return 0;
  return Math.min(Math.max(Math.round(index), 0), count - 1);
}

export function projectIndexFromOffset(offset, step, count) {
  if (!Number.isFinite(step) || step <= 0) return 0;
  return clampProjectIndex(Math.abs(offset) / step, count);
}

export const revealViewport = Object.freeze({
  once: true,
  amount: 0.22
});

export const sectionReveal = {
  hidden: { opacity: 0, y: 72, clipPath: "inset(0 0 100% 0)" },
  visible: {
    opacity: 1,
    y: 0,
    clipPath: "inset(0 0 0% 0)",
    transition: {
      duration: MOTION_TIMING.sectionDuration,
      ease: editorialEase
    }
  }
};
